var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalFirstTip = ModalFirstTip;
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dsWeb = require("@olxbr/ds-web");
var _chatModReactComponentsWeb = require("@olxbr/chat-mod-react-components-web");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className"];
var _this = this,
  _jsxFileName = "/Users/natalia.silva/Documents/OLX-PROJECTS/chatmod-react-components/packages/tips/src/components/ModalFirstTip/index.js",
  _templateObject;
var CustomModal = function CustomModal(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var contentClassName = "".concat(className, "__content");
  var overlayClassName = "".concat(className, "__overlay");
  return (0, _jsxRuntime.jsx)(_reactModal["default"], Object.assign({
    className: contentClassName,
    overlayClassName: overlayClassName
  }, props));
};
CustomModal.propTypes = {
  className: _propTypes["default"].string.isRequired
};
var StyledModal = (0, _styledComponents["default"])(CustomModal)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  &__content {\n    max-width: 560px;\n    width: 90%;\n    overflow: none;\n    outline: none;\n    \n    ", ";\n  }\n\n  &__overlay {\n    display: block;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.72);\n    z-index: 1000;\n  }\n}\n"])), function (_ref2) {
  var isFullScreen = _ref2.isFullScreen;
  return isFullScreen ? '' : "top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      position: absolute;\n    ";
});
function ModalFirstTip(_ref3) {
  var _this2 = this;
  var isOpen = _ref3.isOpen,
    isMsite = _ref3.isMsite,
    texts = _ref3.texts,
    description = _ref3.description,
    idLocalStorage = _ref3.idLocalStorage,
    onCloseModal = _ref3.onCloseModal,
    showEvaluation = _ref3.showEvaluation,
    chatId = _ref3.chatId;
  if (!isOpen) {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return (0, _jsxRuntime.jsx)(StyledModal, {
    ariaHideApp: false,
    isOpen: isOpen,
    contentLabel: "dialog",
    isFullScreen: true,
    testId: "modal-security-box",
    children: (0, _jsxRuntime.jsx)(_dsWeb.Modal, {
      open: isOpen,
      closeCallback: onCloseModal,
      maxHeight: 500,
      children: (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: [isMsite ? (0, _jsxRuntime.jsx)(_dsWeb.Text.SubtitleMedium, {
          children: texts.title
        }) : (0, _jsxRuntime.jsx)(_dsWeb.Text.SubtitleLarge, {
          children: texts.title
        }), (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
          alignItems: "flex-start",
          flexDirection: "column",
          marginTop: "--spacing-2",
          children: [texts.items.map(function (item) {
            return (0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
              flexDirection: "row",
              marginBottom: "--spacing-1-5",
              children: [item.icon, item.text]
            }, item.id);
          }), description]
        }), showEvaluation && (0, _jsxRuntime.jsx)(_chatModReactComponentsWeb.RateBox, {
          luckerDetail: "first-tip-modal-rate",
          idLocalStorage: idLocalStorage,
          isMobile: isMsite,
          chatId: chatId
        })]
      })
    })
  });
}
var _default = ModalFirstTip;
exports["default"] = _default;